import React, {  useState, Fragment } from "react"
import Layout from "../components/layout/index"
import { H1, H4 } from '../components/headings/index'
import { Tabs, Tab } from '../components/tabs/index'
import Container from '../components/container/index'
import SEO from "../components/seo"
import FAQ from '../components/partials/faq'
import Video from '../components/video/index'
import { InternalHeader, FaqImageWrapper, FaqTitleWrapper, FaqItemWrapper, FaqItem as FaqItemCopy, ArrowWrapper } from '../components/partials/style'
import IllustraFaq from '../images/ilustra-faq.svg'
import { ReactComponent as Arrow } from '../images/arrow.svg'

const FaqTitle = props => {
  const { onClick, index, currentQuestionIndex, question, isActive } = props

  return (
    <FaqTitleWrapper>
      <button 
        onClick={ onClick } 
        aria-expanded={ (currentQuestionIndex === index).toString() } 
        aria-controls={`faq_desc_${index}`}>
        <H4 weight={ isActive ? 800 : 400 }>{question}</H4>
        <ArrowWrapper isActive={isActive}>
          <Arrow />
        </ArrowWrapper>
      </button>
    </FaqTitleWrapper>
  )
}

const FAQpage = () => {

  const [ questionIndex, setQuestionIndex ] = useState( null );

  const faqImobiliaria = [
    {
      question: "O que é a FicaAzul?",
      answer: "A FicaAzul é uma plataforma para negociação de dívidas voltada para o mercado imobiliário. Com ela, imobiliárias podem negociar dívidas de clientes que sejam relacionadas aos imóveis, sejam elas de locação ou de venda."
    },
    {
      question: "Como solicitar o cadastro?",
      answer: "Caso você seja um usuário CredPago, você pode usar o FicaAzul utilizando seu login da CredPago.",
      video: "ffOPrkpkQvA"
    },
    {
      question: "Quais tipos de dívidas eu posso cobrar?",
      answer: "Na FicaAzul todos os tipos de dívidas que são administradas pela imobiliária podem ser negociadas. Com por exemplo, inadimplências de aluguéis que tenham o fiador como garantia, parcelas de financiamento de imóveis ou taxas administrativas."
    },
    {
      question: "Posso solicitar a negociação de dívidas que ainda não venceram?",
      answer: "Sim. Imobiliárias poderão solicitar negociação tanto de dívidas que ainda não venceram quanto pendências já vencidas."
    },
    {
      question: "Como deve ser solicitada a negociação?",
      answer: "A imobiliária deverá acessar a plataforma de negociação com seu login e senha, inserir as informações do cliente e da cobrança a ser realizada. Ao confirmar todos as informações no resumo da cobrança, a imobiliária clica em um botão para enviar a negociação.",
      video: "EtotKxrZd5o"
    },
    {
      question: "Imobiliárias já cadastradas com CredPago, precisam se cadastrar na plataforma FicaAzul?",
      answer: "Sim. Mesmo as imobiliárias que já são cadastradas com a CredPago deverão se cadastrar na plataforma FicaAzul para utilizarem os serviços de negociação de dívidas."
    },
    {
      question: "Quem pode solicitar a negociação de uma dívida?",
      answer: "As solicitações para negociação de uma dívida podem ser feitas por imobiliárias cadastradas na FicaAzul."
    },
    {
      question: "Como funciona todo processo entre negociar e receber valores negociados?",
      answer: "A imobiliária entra na plataforma para solicitar a negociação informando todos os dados solicitados em relação a dívida a ser negociada. Em seguida a imobiliária escolhe como deseja receber os valores. Quando o cliente aceitar a negociação, então a imobiliária receberá os valores conforme indicou na plataforma."
    },
    {
      question: "Após fazer uma negociação, como a imobiliária recebe esses valores?",
      answer: "O repasse de valores negociados é feito diretamente para a conta bancária cadastrada pela imobiliária. O mesmo é feito dentro de 5 dias úteis após o pagamento do cliente."
    },
    {
      question: "Para quem essa ferramenta é indicada?",
      answer: "A ferramenta FicaAzul é indicada para imobiliárias que não possuem um setor de cobrança dedicado e que querem facilitar o recebimento de inadimplências."
    },
    {
      question: "Qual o custo de uso da ferramenta?",
      answer: "Para imobiliárias não há custos para uso da ferramenta."
    },
    {
      question: "Quais são os juros aplicados nas dívidas que serão negociadas?",
      answer: "Os juros a serem aplicados sobre os valores negociados serão inseridos pela imobiliária na hora de preencher a solicitação na plataforma."
    }
  ]

  const faqCliente = [
    {
      question: "Como aceitar a negociação",
      video: "TD0iWCJkpKU"
    },
    {
      question: "Como posso solicitar uma negociação com uma imobiliária?",
      answer: "Se você é cliente de uma imobiliária e quer solicitar uma negociação através do FicaAzul, você deverá primeiramente entrar em contato com a imobiliária, pois a mesma quem deverá criar um acesso na plataforma para solicitar uma negociação."
    },
    {
      question: "Quais são as formas e condições de pagamento que posso escolher ao negociar uma dívida?",
      answer: "O cliente poderá escolher as seguintes opções para quitar a dívida: cartão de crédito em até 12 parcelas, boleto e TED em uma parcela única."
    },
    {
      question: "Negociei minha dívida com o FicaAzul e não paguei, o que eu faço?",
      answer: "Caso não tenha conseguido cumprir com o pagamento, você deve solicitar uma renegociação, e para isso, entre em contato com o FicaAzul pelo 0800 001 6002."
    },
    {
      question: "Se eu negociar uma dívida pela plataforma e atrasar o pagamento, o que ocorre?",
      answer: "Caso escolha a opção de pagar a dívida via boleto e atrase o pagamento do mesmo, você deverá solicitar a segunda via do mesmo na qual terá as devidas correções e ajustes de valores devido o atraso."
    },
    {
      question: "Como faço para tirar uma segunda via do boleto?",
      answer: "Para retirar uma segunda via do boleto, você precisa entrar em contato com o time de atendimento do FicaAzul pelo 0800 001 6002."
    },
    {
      question: "Quanto tempo leva para o pagamento aparecer no sistema?",
      answer: "O tempo que o sistema leva para validar o pagamento do cliente depende da forma de pagamento: boleto leva até 2 dias úteis, já cartão de crédito e TED leva apenas 1 dia útil."
    },
    {
      question: "Já se passaram 03 dias e o meu pagamento ainda não foi identificado, o que devo fazer?",
      answer: "Caso o seu pagamento não seja identificado no tempo de até 03 dias úteis, você deve entrar em contato para informar o ocorrido através do 0800 001 6002."
    },
    {
      question: "Não recebi retorno da imobiliária da contraproposta, o que faço?",
      answer: "Caso não tenha recebido retorno da sua contraproposta para a imobiliária em até 5 dias úteis, entre em contato com a FicaAzul pelo telefone 0800 001 6002."
    },
    {
      question: "Como consigo uma carta de quitação da minha dívida?",
      answer: "Ao realizar o pagamento da dívida negociada, você cliente recebe em seu e-mail o comprovante e o recibo de pagamento da dívida."
    },
    {
      question: "Não reconheço a dívida que estão me cobrando, o que devo fazer?",
      answer: "Ao receber uma notificação de dívida, você tem a opção de informar que não reconhece a dívida enviada. Portanto, ao receber uma cobrança desconhecida, informe no local indicado."
    },
    {
      question: "Quais são os custos da operação?",
      answer: "A taxa para utilização da ferramenta é de 10% sobre o valor da dívida negociada. Caso o cliente opte por pagar por cartão de crédito, será cobrado a taxa MDR de 2,5%. Se o pagamento for via boleto, o custo é de R$ 6,00."
    }
  ]

  const FaqItem = props => {
    const { question, onClick, index, isActive, answer, video } = props

    return (
      <FaqItemWrapper>
        <FaqTitle 
          question={question}
          onClick={onClick}
          isActive={isActive}
          index={index} />
        <FaqItemCopy style={{ maxHeight: isActive ? '99999px' : '0px' }}>
          {video && (
            <Video 
              style={{ marginBottom: ( answer ? '20px' : 0 ) }}
              youtubeId={video} />
          )}
          <p id={`faq_desc_${index}`} className="desc">
            {answer}
          </p>
        </FaqItemCopy>
      </FaqItemWrapper>
    )
  }

  return (
    <Layout paintHeader={true}>
      <SEO 
        title="FAQ - Dúvidas Frequentes" 
        description="FicaAzul - O jeito fácil de negociar"
        url="/faq"
        image={'/images/share/square.jpg'}
      />
      <Container>
        <InternalHeader>
          <H1><span>FAQ - </span>Dúvidas Frequentes</H1>
          <p>Nesta página você pode tirar todas suas dúvidas sobre a FicaAzul. Caso você ainda tenha alguma dúvida que não está no FAQ, entre em contato pelo email <strong>ficaazul@credpago.com</strong> ou então entre em contato pelo telefone <strong>0800 001 6002</strong></p>
        </InternalHeader>

        <FaqImageWrapper>
          <img 
            src={IllustraFaq} 
            width='469' 
            alt="Perguntas Frequentes FicaAzul" />
        </FaqImageWrapper>

        <Tabs
          afterTabChange={() => setQuestionIndex(null)}
          >
          <Tab 
            label="Sou Imobiliária/Corretor">

            <FAQ>
              {faqImobiliaria.map( (item, index) => {
                return (
                  <Fragment key={index}>
                    <FaqItem 
                      question={item.question}
                      onClick={() => setQuestionIndex(index)}
                      index={index}
                      isActive={(questionIndex === index)}
                      answer={item.answer}
                      video={item.video}
                      />
                  </Fragment>
                )
              })}
            </FAQ>
          </Tab>
          <Tab
            label="Sou Cliente">
              <FAQ>
                {faqCliente.map( (item, index) => {
                  return (
                    <Fragment key={index}>
                      <FaqItem 
                        question={item.question}
                        onClick={() => setQuestionIndex(index)}
                        index={index}
                        isActive={(questionIndex === index)}
                        answer={item.answer}
                        video={item.video}
                        />
                    </Fragment>
                  )
                })}
              </FAQ>
          </Tab>
        </Tabs>
      </Container>
    </Layout>
  )
}

export default FAQpage
